import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './PasswordForget';
import { auth } from '../../firebase';

import '../../global.css';
import './SignIn.css';

const SignInPage = ({ history }) =>
    <div className="main">
        <div className="mostly-opaque-white">

        <SignInForm history={history} />
        </div>
    </div>;

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
};

class SignInForm extends Component {

   constructor(props) {
      super(props);
      const {
         history,
      } = this.props;

      const fromAccountPage = history.location.state && history.location.state.onAccount;
      this.state = {...INITIAL_STATE, onAccount: fromAccountPage};

      // Parses all params of url (i.e. www.test.com?foo=bar&test=val)
      var regex = /[?&]([^=#]+)=([^&#]*)/g,
         url = window.location.href,
         params = {},
         match;
      // eslint-disable-next-line
      while (match = regex.exec(url)) {
         params[match[1]] = decodeURIComponent(match[2]);
      }

      const creds = params.creds
      // Autologin if credentials exists
      if (typeof creds === 'string' || creds instanceof String) {
         auth.doTokenSignIn(creds).then(creds => {
            this.setState(() => ({...INITIAL_STATE}));
            history.push('/home');
         }).catch(error => {
            console.error("creds rejected", error)
         })
      }
   }

    onSubmit = (event) => {
        const {
            email,
            password,
        } = this.state;

        const {
            history,
        } = this.props;

        auth.doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState(() => ({ ...INITIAL_STATE }));
               if (this.state.onAccount) {
                   history.push('./account')
                } else {
                   history.push('/home');
                }
            })
            .catch(error => {
                this.setState(byPropKey('error', error));
            });

        event.preventDefault();
    };

    render() {
        const {
            email,
            password,
            error,
        } = this.state;

        const isInvalid =
            password === '' ||
            email === '';

        const heading = this.state.onAccount ? "Re-Sign in to continue" : "Please sign in";
        const buttonText = this.state.onAccount ? "Continue" : "Sign in";

        return (
            /*
            <form onSubmit={this.onSubmit}>
                <input
                    value={email}
                    onChange={event => this.setState(byPropKey('email', event.target.value))}
                    type="text"
                    placeholder="Email Address"
                />
                <input
                    value={password}
                    onChange={event => this.setState(byPropKey('password', event.target.value))}
                    type="password"
                    placeholder="Password"
                />
                <button disabled={isInvalid} type="submit">
                    Sign In
                </button>

                { error && <p>{error.message}</p> }
            </form>
            */
            <form className = "form-signin" onSubmit={this.onSubmit}>
                <h2 className="big-bottom-margin">
                   {heading}
                </h2>

                <input
                    type="email"
                    id="inputEmail"
                    onChange={event => this.setState(byPropKey('email', event.target.value))}
                    value={email}
                    className="form-control"
                    placeholder="Email address"
                    required autoFocus/>

                <input
                    type="password"
                    value={password}
                    onChange={event => this.setState(byPropKey('password', event.target.value))}
                    id="inputPassword"
                    className="form-control bottom-margin"
                    placeholder="Password" required/>

                { error && <p className="text-danger">{error.message}</p> }

                <button
                    disabled={isInvalid}
                    className="btn btn-lg btn-primary btn-block big-top-margin bottom-margin"
                    type="submit">
                   {buttonText}
                </button>

                <PasswordForgetLink />
                <SignUpLink />
            </form>
        );
    }
}

export default withRouter(SignInPage);

export {
    SignInForm,
};



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js